import React from "react";

import { OverviewTabs2025, OverviewTabs2025Props } from "./2025";

interface IOverviewTabsWrapper extends OverviewTabs2025Props {}

export const OverviewTabsWrapper = (props: IOverviewTabsWrapper): JSX.Element => {
  return <OverviewTabs2025 {...props} />;
};
